import { useSelector } from "react-redux";
import ElementaryPage from "./elementary/ElementaryPage";
import IntermediatePage from "./intermediate/IntermediatePage";
import AdvancedPage from "./advanced/AdvancedPage";
import StepsBar from "../../widgets/StepsBar";
import { getContentHeight } from "../../../../../utils/textUtils";

// ⚠ 구문분석은 재구축 금지 — 내부 UI는 레포 원본 그대로.
// 변경은 이 파일에서 상단 스텝바(StepsBar)를 붙이는 것 하나뿐이다.
// (레벨 페이지의 height:getContentHeight()→"100%"는 껍데기 높이 보정용 필수 1줄)
// 리더스북 · 파닉스북 구문분석(2026-10-20)은 지문분석 단계가 아니라서 스텝바를 감춘다(showStepsBar).
// 검토(isReview)는 여기서 끊기고 있었다. 아래 레벨 화면이 그 값으로 저장을
// 막는데 받지 못해, 교사가 학생 답안을 보며 누른 것이 그대로 저장됐다.
const SyntaxAnalysisPage = ({ setCurrentStep, isPreview, isReview, showStepsBar = true }) => {
  const { section } = useSelector((state) => state.assignment);

  let levelPage = <div></div>;
  if (section?.question.level === "elementary") {
    levelPage = (
      <ElementaryPage
        section={section}
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (section?.question.level === "intermediate") {
    levelPage = (
      <IntermediatePage
        section={section}
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (section?.question.level === "advanced") {
    levelPage = (
      <AdvancedPage
        section={section}
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  }

  return (
    <div
      style={{
        height: getContentHeight(),
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#FFFFFF",
      }}
    >
      {showStepsBar && <StepsBar />}
      <div style={{ flex: 1, minHeight: 0, overflow: "hidden" }}>{levelPage}</div>
    </div>
  );
};

export default SyntaxAnalysisPage;
